module.exports = __webpack_public_path__ + "img/feature-icon3.b6ce5090.png";